var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Search-Box-/-SKU",
    transform: "translate(-40.000000, -9.000000)",
    fill: "#131A1E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyphs-/-8x-/-Remove",
    transform: "translate(40.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58578644,4 L0.110912703,1.52512627 L1.52512627,0.110912703 L4,2.58578644 L6.47487373,0.110912703 L7.8890873,1.52512627 L5.41421356,4 L7.8890873,6.47487373 L6.47487373,7.8890873 L4,5.41421356 L1.52512627,7.8890873 L0.110912703,6.47487373 L2.58578644,4 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.d8f62cafc775f86f7b76915421d72cd0.svg";
export { ForwardRef as ReactComponent };